import { useState, FC, ReactElement, useEffect, useRef } from 'react';
import { AcquisitionOptions } from 'apps/acp/packages/acquire-new-customer';
import {
  AppsflyerAttributionData,
  AppsflyerPlugin,
  UnifiedData
} from 'packages/appsflyer-plugin/api';

const win = window as any;

export const AppsflyerListener: FC<{
  appsflyerPlugin: AppsflyerPlugin;
  children: (props: {
    options: AcquisitionOptions;
    isAcquisition: boolean;
  }) => ReactElement | null;
}> = ({ appsflyerPlugin, children }) => {
  const [appsflyerResponse, setAppsflyerResponse] = useState<
    UnifiedData | AppsflyerAttributionData
  >();
  const isAcquisition = useRef(false);

  useEffect(() => {
    try {
      //unified deep linking
      appsflyerPlugin.unifiedDeepLinkEvent((res: UnifiedData) => {
        if (res) {
          const { deep_link_value } = res;
          if (deep_link_value) {
            if (deep_link_value?.indexOf('acquisition') > -1) {
              isAcquisition.current = true;
              setAppsflyerResponse(res);
            } else {
              if (!sessionStorage.getItem('acp_pre_onboarding_loaded')) {
                sessionStorage.setItem(
                  'acp_pre_onboarding_loaded',
                  btoa('true')
                );
              }
              appsflyerPlugin.trackInAppEvent(
                deep_link_value.split('account/')[1],
                { campaign: res.campaign }
              );
              window.location.assign(deep_link_value);
            }
          }
        }
      });

      appsflyerPlugin.initSdk(5000);
    } catch (error) {
      win.console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options: AcquisitionOptions = Object.assign(
    { use_absolute_parameters: true },
    appsflyerResponse?.deep_link_sub2
      ? { site_id: appsflyerResponse?.deep_link_sub2 }
      : null,
    appsflyerResponse?.deep_link_sub1
      ? { aid: appsflyerResponse?.deep_link_sub1 }
      : null,
    appsflyerResponse?.af_sub1 ? { sub: appsflyerResponse?.af_sub1 } : null,
    appsflyerResponse?.af_sub2 ? { adid: appsflyerResponse?.af_sub2 } : null
  );

  return children({ options, isAcquisition: isAcquisition.current });
};
